<template>
    <div class="number-filter" v-if="modelValue">
        <el-input v-model.number="modelValue[0]" placeholder="大于" @keydown.enter.stop="$emit('search',modelValue)"/>
        <span>-</span>
        <el-input v-model.nu.number="modelValue[1]" placeholder="小于" @keydown.enter.stop="$emit('search',modelValue)"/>
    </div>
</template>
<script>
import {ref, watch} from 'vue'

export default {
    name: 'NumberFilter',
    props: {
        column: {
            type: Object,
            default: () => ({})
        },
        modelValue: {
            type: Array,
            required: true
        }
    },
    setup(props, context) {
        if (!props.modelValue) {
            context.emit('update:modelValue', [])
        }
    }
}
</script>
<style scoped>
.number-filter {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
}
</style>